import { VehicleFeatureModel } from './../../../models/VehicleFeatureModel';
import { AttachmentService } from 'src/app/services/attachment.service';
import { ViewBookingViewModeEnum } from './../../../models/enums/ViewBooking/ViewBookingEnum';
import { SelectedVehicleService } from './../../../services/selectedVehicle.service';
import { AuthService } from 'src/app/services/auth.service';
import { SearchService } from 'src/app/services/search.service';
import { TranslateService } from '@ngx-translate/core';
import { GoogleMapPinComponent } from 'src/app/views/booking/google-map-pin/google-map-pin.component';
import { LoadingService } from './../../../services/loading.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { VehicleReservationState } from './../../../models/enums/BookingEnums';
import { ExtendRentalTimeModalComponent } from './../extend-rental-time-modal/extend-rental-time-modal.component';
import { BookingService } from 'src/app/services/booking.service';
import { ModificationTypeModalComponent } from './../modification-type-modal/modification-type-modal.component';
import { CancelationModalComponent } from './../cancelation-modal/cancelation-modal.component';
import { AddReviewsComponent } from './../add-reviews/add-reviews.component';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { faCalendarAlt, faBusinessTime, faChevronCircleLeft, faChevronCircleRight, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';
import { ViewChild } from '@angular/core';
import { CountdownComponent } from 'ngx-countdown';
import { DomSanitizer } from "@angular/platform-browser";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { ActivatedRoute, Router } from '@angular/router';
import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';
import { VehicleReservationCaseResult, WorkflowInstancePossibleAction } from 'src/app/models/Booking/VehicleReservationCaseResult';
import { WorkflowInstancePossibleActionEnum } from 'src/app/models/enums/BookingEnums';
import { FormControl, FormBuilder } from '@angular/forms';
import { TooltipPosition } from '@angular/material/tooltip';
import { NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { IconService } from './../../../services/icon.service';
import { CampaignsReservationCaseModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { DateFormatPipe } from 'src/app/common/pipes/DateFormatPipe';

@Component({
  selector: 'view-booking',
  templateUrl: './view-booking.component.html',
  styleUrls: ['./view-booking.component.css'],

})
export class ViewBookingComponent implements OnInit,OnDestroy {
  showCountDown = false;
  viewMode: ViewBookingViewModeEnum = ViewBookingViewModeEnum.Default;
  campaignsReservationCaseModel:CampaignsReservationCaseModel;
  contarctURL;



  constructor(

    private searchService: SearchService,
    private authService: AuthService,
    private _formBuilder: FormBuilder, service: SearchService,
    private bookingService: BookingService,
    private router: Router,
    private loadingService: LoadingService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private dialog: MatDialog,
    private bookinService: BookingService,
    private selectedVehcileService: SelectedVehicleService,
    private route: ActivatedRoute,
    config: NgbPopoverConfig,
    public translateService: TranslateService,
    private iconService: IconService,
    private attachmnetService:AttachmentService,
    private _dateFormatPipe: DateFormatPipe,
  ) {
    // this.matIconRegistry.addSvgIcon(
    //   "car-gear",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "car-door",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
    // );
    this.matIconRegistry.addSvgIcon(
      "timeIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.timeIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "supplierMapIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.supplierMapIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "lateReturn",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.lateReturn)
    );
    this.matIconRegistry.addSvgIcon(
      "rentalContractExtension",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.rentalContractExtension)
    );
    this.matIconRegistry.addSvgIcon(
      "rentalContractTermination",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.rentalContractTermination)
    );
    this.matIconRegistry.addSvgIcon(
      "rentalReplacement",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.rentalReplacement)
    );

    config.placement = 'right';
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(item =>{
      item.unsubscribe();
    })
  }

  workflowInstancePossibleAction: WorkflowInstancePossibleAction[];

  faMapMarkerAlt = faMapMarkerAlt;
  faCalendarAlt = faCalendarAlt;
  faBusinessTime = faBusinessTime;
  viewBooking: ViewBookingModel;

  reservationCaseResultData: any;
  closedStatus: any;
  reservationCaseResult;

  subscriptions:Subscription[]=[];




  ngOnInit() {

    /*   setTimeout(() => {
        this.loadingService.updateLoadingState(true);
      }); */
    let caseID = this.route.snapshot.paramMap.get('CaseID');
    this.reservationCaseResultData = new BehaviorSubject({});
    if (caseID != null) {
      //this.bookinService.updateViewBookingState();

      this.subscriptions.push(this.bookinService.viewBookingState.subscribe(res => {

        this.loadData(caseID);
      }));

    }



  }

  get workflowInstancePossibleActionEnum(): typeof WorkflowInstancePossibleActionEnum {
    return WorkflowInstancePossibleActionEnum;
  }

  get viewBookingViewModeEnum() {
    return ViewBookingViewModeEnum;
  }
  get vehicleReservationState(){
    return VehicleReservationState;
  }
  get AttachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get AttachmentTypeEnum() {
    return AttachmentTypeEnum;
  }


  loadData(caseID) {
    this.bookinService.CaseID = caseID;

    this.subscriptions.push(this.bookinService.getVehicleReservationCase(caseID).subscribe(res => {


      res.caseStateID
      this.reservationCaseResult = res;
      this.contarctURL = this.reservationCaseResult.contractURl

      this.campaignsReservationCaseModel=res.vehicleReservationDetailsModel.campaignsReservationCaseModel;
      //this.ExpiryDate =  this._dateFormatPipe.transform(this.campaignsReservationCaseModel.endDate),


      this.reservationCaseResultData.next(res);
      this.bookinService.updateVehicleReservationCaseResult(res);
      this.workflowInstancePossibleAction = res.workflowInstancePossibleAction;


      let _viewBooking = this.bookinService.reservationCaseToViewBookingModel(res);
      this.viewBooking = _viewBooking;


      this.bookinService.updateViewBookingModel(_viewBooking);

      if (res != null) {
        if (res.caseStateID == VehicleReservationState.Confirmed) {
          this.showCountDown = true;
        }
        else {
          this.showCountDown = false;
        }

        let vehicle = this.bookinService.fetchVehicleFromVehicleReservationCase(res);
        this.bookinService.updateVehicle(vehicle);
        this.selectedVehcileService.updateVehicle(vehicle);
        // this.loadingService.updateLoadingState(false);

        if (res.caseStateID == VehicleReservationState.FinalClose) {
           this.closedStatus = VehicleReservationState.Closed
           this.viewBooking.caseStatus = this.closedStatus ;
        }




      }

    }));
  }

  /*CountDown */
  status = 'start';
  @ViewChild('countdown') counter: CountdownComponent;
  finishTest() {
    this.status = 'finished';
    this.counter.restart();
  }
  resetTimer() {
    this.counter.restart();
  }

  openAddReview() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef=this.dialog.open(AddReviewsComponent, { panelClass: 'add-review-modal' });
    dialogRef.afterClosed().subscribe(
      data => {
        if (data != null) {
          this.bookinService.updateReviewAddedStatus(true);
          this.ngOnInit();
        }
      }
    );
  }

  openCancel() {
    const dialogConfig = new MatDialogConfig();
    this.dialog.open(CancelationModalComponent, dialogConfig);
  }

  openModificationType() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef=this.dialog.open(ModificationTypeModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.viewMode=result.option;

      });
  }

  openExtend() {
    const dialogConfig = new MatDialogConfig();
    //this.dialog.open(ExtendRentalTimeModalComponent, { panelClass: 'extend-rental-time-modal' });

    this.viewMode = ViewBookingViewModeEnum.Extend;
    //this.router.navigate(['/extend-rental-time']);
    //this.dialogRef.close();
  }
  openAgencyMap() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      isDraggable: false,
      position: {
        latitude: this.viewBooking.latitude,
        longitude: this.viewBooking.longitude,
        address:this.viewBooking.summaryChargePickUpLocationAddress
      }
    }
    this.dialog.open(GoogleMapPinComponent, dialogConfig);
  }
  resetViewMode(viewMode?){
    this.viewMode=ViewBookingViewModeEnum.Default;

    /*
    This is to resolve a bug when editing charge-summary component and return to view-booking
    The charge-summary-view-booking got the change that not saved from add-remove or update-rental
    So for now we will reset the view, TODO: is to debug the issue why the change move to view mode
    */
    if(viewMode==ViewBookingViewModeEnum.Extend){
      this.ngOnInit();
    }
    else if(viewMode==ViewBookingViewModeEnum.AddRemoveExtras){
      this.ngOnInit();
    }
  }

  downloadContract(){

    window.open(this.contarctURL,"_blank")
  }




}
